export enum EI18n {
  en = "eng",
  ru = "rus",
}
